import React from "react";
import { Button } from "react-bootstrap";
import CustomTable from "../../helpers/customtable";
import { orderScriptsNewestFirst } from "./scriptsListUtils";
import "../../../css/ScriptsTable.css";

export default function ScriptsList({ scripts, t, onCreate, onEdit, onDuplicate, onDelete }) {
  const column = (key, header, width) => ({
    key, header: t(header), shortHeader: t(`scriptsHeaderShort_${header}`),
    width, align: "left", default: t("none"),
  });
  const config = {
    rowKey: "scriptId", emptyText: t("noScripts"), pageSize: 10,
    showPageSizeSelector: true, pageSizeOptions: [10, 25, 50, 100], showTotalCount: true,
    labels: { filter: t("filter"), search: t("search"), actions: t("actions") },
    columns: [
      column("scriptId", "id", "10%"),
      { ...column("name", "name", "50%"), fixed: true },
      column("room", "room", "35%"),
      { key: "actions", width: "5%", text: "...", appearOnHover: true, actionlist: [
        { key: "edit", label: t("modify"), icon: "bi-pencil", onClick: (script) => onEdit(script.scriptId) },
        { key: "duplicate", label: t("scriptsDuplicate"), icon: "bi-copy", onClick: (script) => onDuplicate(script) },
        { key: "delete", label: t("delete"), icon: "bi-trash", onClick: (script) => onDelete(script.scriptId) },
      ] },
    ],
    onRowClick: (script) => onEdit(script.scriptId),
  };
  return <>
    <Button className="mb-3" onClick={onCreate}>{t("createNewScript")}</Button>
    <div className="scripts-table"><CustomTable data={orderScriptsNewestFirst(scripts)} config={config} /></div>
  </>;
}
